package com.example.hukakmp.voice

import kotlinx.browser.window

actual object VoiceDictation {
    private var activeRecognition: dynamic = null

    actual val available: Boolean
        get() {
            val browser = window.asDynamic()
            return browser.SpeechRecognition != undefined ||
                browser.webkitSpeechRecognition != undefined
        }

    actual fun start(
        onResult: (String) -> Unit,
        onError: (String) -> Unit,
        onEnd: () -> Unit,
    ): Boolean {
        if (!available) return false

        return try {
            stop()

            val recognition: dynamic =
                js("new (window.SpeechRecognition || window.webkitSpeechRecognition)()")

            recognition.lang = "es-AR"
            recognition.continuous = false
            recognition.interimResults = false
            recognition.maxAlternatives = 1

            recognition.onresult = { event: dynamic ->
                val transcript = event.results[0][0].transcript?.toString()?.trim().orEmpty()
                if (transcript.isNotBlank()) {
                    onResult(transcript)
                }
                Unit
            }

            recognition.onerror = { event: dynamic ->
                val code = event.error?.toString().orEmpty()
                val message = when (code) {
                    "not-allowed", "service-not-allowed" ->
                        "No pude usar el micrófono. Revisá el permiso del navegador."
                    "no-speech" ->
                        "No detecté voz. Probá de nuevo hablando un poco más cerca del micrófono."
                    "audio-capture" ->
                        "No encontré un micrófono disponible."
                    "network" ->
                        "El reconocimiento de voz no pudo conectarse."
                    "aborted" ->
                        "Dictado cancelado."
                    else ->
                        "No pude transcribir el audio."
                }
                onError(message)
                Unit
            }

            recognition.onend = {
                activeRecognition = null
                onEnd()
                Unit
            }

            activeRecognition = recognition
            recognition.start()
            true
        } catch (_: Throwable) {
            activeRecognition = null
            onError("No pude iniciar el dictado en este navegador.")
            onEnd()
            false
        }
    }

    actual fun stop() {
        val recognition = activeRecognition ?: return
        runCatching { recognition.stop() }
        activeRecognition = null
    }
}
